import { render, staticRenderFns } from "./InsertDeadSpecimen.vue?vue&type=template&id=5c745b64"
import script from "./InsertDeadSpecimen.vue?vue&type=script&lang=js"
export * from "./InsertDeadSpecimen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports